import { RGBELoader } from 'three/addons/loaders/RGBELoader.js'

const rgbeLoader = new RGBELoader()

export default async function loadHDR(url) {
    return new Promise((resolve, reject) => {
        rgbeLoader.load(url, resolve, undefined, reject)
    })
}

loadHDR.loader = {
    name: 'hdr',
    extensions: ['.hdr', '.exr'],
}
